import '../../Assets/Styles/home.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom'; // ⬅️ ADICIONADO useParams

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Divider } from 'primereact/divider';
import { Tooltip } from 'primereact/tooltip'; // ⬅️ ADICIONADO Tooltip

import { Grid } from '@mui/material';

import jwtDecode from 'jwt-decode';

import * as AppActions from '../../Store/Actions/App'
import * as LoginActions from '../../Store/Actions/Login'
import * as UserActions from '../../Store/Actions/User'

import AlertView from '../../Components/AlertModal';

import HomeCards from '../../Components/HomeCards/HotelCards';
import AboutUs from '../../Components/layout/AboutUs';
import ContactUs from '../../Components/layout/ContactUs';

import {
    validarEmail
} from '../../Components/Utils';

const PasswordSetup = (props) => {

  const {
    createPassword
  } = props;

  const navigate = useNavigate();
  const { token } = useParams(); // ⬅️ pega TOKEN de /usuario/definir-senha/:token

  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })

  const [saving, setSaving] = React.useState(false); 
  const [alert, setAlert] = React.useState(false); 
  const [alertTitle, setAlertTitle] = React.useState("Informações"); 
  const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 
  const [pendingRedirect, setPendingRedirect] = React.useState(null); // ⬅️ para redirecionar ao fechar o alerta

  const [password, setPassword] = React.useState('');
  const [passwordConfirm, setPasswordConfirm] = React.useState('');

  // Estados de token
  const [decodedToken, setDecodedToken] = React.useState(null);
  const [tokenValid, setTokenValid] = React.useState(false);
  const [tokenExpired, setTokenExpired] = React.useState(false);
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  // Painel de dica de senha (mantido do arquivo)
  const PasswordTip = (
    <>
      <Divider />
      <p className="mt-1" style={{fontSize:"0.9rem"}}>Sugestão de senha</p>
      <ul className="pl-2 ml-2 mt-0 line-height-3" style={{fontSize:"0.8rem"}}>
        <li>Ao menos 1 letra maiúscula</li>
        <li>Ao menos 1 letra minúscula</li>
        <li>Ao menos 1 número </li>
        <li>Ao menos 1 símbolo ! # $ % & * + - = ? @ </li>
        <li>De 6 a 12 caracteres</li>
      </ul>
    </>
  );

  /* Execute recaptcha */
  const recaptchaRef = window.grecaptcha;
  const executeReCaptcha = async () => {
    const token = await recaptchaRef.execute();
    return token;
  }

  // ⬅️ Validações iniciais (token + login)
  React.useEffect(() => {
    // 1) Usuário logado?
    try {
      const userDataStr = localStorage.getItem("@dream4/userData");
      if (userDataStr) {
        setIsLoggedIn(true);
        setAlertTitle("Você já está logado");
        setAlertBody("Não é possível criar a senha enquanto estiver logado. Faça logoff e acesse novamente o link recebido por e-mail para definir sua senha.");
        setAlert(true);
        setPendingRedirect("/order");
        return; // não segue validações do token com usuário logado
      }
    } catch(e) {
      // ignora erros de localStorage
    }

    // 2) Token foi informado?
    if (!token || typeof token !== "string" || token.trim() === "") {
      setAlertTitle("Link inválido");
      setAlertBody("O link para definir a senha é inválido ou está ausente. Solicite um novo e-mail e tente novamente.");
      setAlert(true);
      setPendingRedirect("/order");
      return;
    }

    // 3) Decodifica e valida propósito/expiração
    try {
      const payload = jwtDecode(token); // import já existe no arquivo original :contentReference[oaicite:3]{index=3}
      setDecodedToken(payload);

      // purpose precisa ser o esperado
      if (payload?.purpose !== "password_setup") {
        setTokenValid(false);
        setAlertTitle("Link inválido");
        setAlertBody("Este link não é válido para a criação de senha.  Entre em contato com a sua agência para solicitar novo link.");
        setAlert(true);
        setPendingRedirect("/order");
        return;
      }

      // exp em segundos (Unix). Compara com o "agora".
      const nowInSeconds = Math.floor(Date.now() / 1000);
      if (typeof payload.exp === "number" && payload.exp > 0) {
        if (payload.exp <= nowInSeconds) {
          setTokenExpired(true);
          setTokenValid(true); // token estruturalmente válido, porém expirado

            setAlertTitle("Link expirado");
            setAlertBody("O link recebido está expirado e não pode ser mais utilizado. Selecione a opção 'login' mais acima e use o recurso de recuperar senha.");
            setAlert(true);

        } else {
          setTokenValid(true);
          setTokenExpired(false);
        }
      } else {
        // sem exp — trata como inválido
        setTokenValid(false);
        setAlertTitle("Link inválido");
        setAlertBody("O link recebido não contém informações de expiração válidas. Selecione a opção 'login' mais acima e use o recurso de recuperar senha.");
        setAlert(true);
        setPendingRedirect("/order");
      }

    } catch (e) {
      setTokenValid(false);
      setAlertTitle("Link inválido");
      setAlertBody("Não foi possível validar o token do link. Entre em contato com a sua agência para solicitar novo link.");
      setAlert(true);
      setPendingRedirect("/order");
    }
  }, [token]);

  // ⬅️ Redireciona quando o alerta for fechado e houver rota pendente
  React.useEffect(() => {
    if (!alert && pendingRedirect) {
      navigate(pendingRedirect);
    }
  }, [alert, pendingRedirect, navigate]);

  // ⬅️ Controle do botão (desabilita em expiração/sem token válido/logado)
  const canSubmit = tokenValid && !tokenExpired && !isLoggedIn && !saving;

  // ⬅️ Mensagem do tooltip de bloqueio
  const disabledReason = isLoggedIn
    ? "Você está logado. Faça logoff para definir a senha pelo link."
    : tokenExpired
      ? "Este link expirou. Selecione a opção 'login' mais acima e use o recurso de recuperar senha."
      : !tokenValid
        ? "Token inválido. Selecione a opção 'login' mais acima e use o recurso de recuperar senha."
        : null;

const savePassword = () => {
  if (!password || !passwordConfirm) {
    setAlert(true);
    setAlertTitle("Verifique as informações");
    setAlertBody("Preencha a nova senha e a confirmação de senha para prosseguir.");	
    return;
  }
  if (password !== passwordConfirm) {
    setAlert(true);
    setAlertTitle("Verifique a senha");
    setAlertBody("O campo de senha deve ser igual ao de confirmação de senha. Verifique.");	
    return;
  }
  const mediumPwd = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
  if (!mediumPwd.test(password)) {
    setAlert(true);
    setAlertTitle("Verifique a senha de acesso");
    setAlertBody("A complexidade da senha deve ser no mínimo média. Verifique.");	
    return;    
  }

  if (!canSubmit) {
    setAlert(true);
    setAlertTitle("Não é possível continuar");
    setAlertBody(disabledReason || "Não é possível prosseguir com a definição de senha.");
    return;
  }

  setSaving(true);

  executeReCaptcha()
    .then(function () {
      const handlers = {
        onSuccess: (data) => {
          setSaving(false);
          setAlertTitle("Tudo certo!");
          setAlertBody("Senha criada com sucesso. Você já pode acessar a plataforma.");
          setAlert(true);
          // redireciona após fechar (opcional):
          setPendingRedirect("/home");
        },
        onError: (msg, data) => {
          setSaving(false);

          // Mapeia flags conhecidas
          if (data?.expiredToken) {
            setAlertTitle("Link expirado");
            setAlertBody("Este link está expirado. Solicite um novo e-mail para definir a senha.");
          } else if (data?.invalidToken) {
            setAlertTitle("Link inválido");
            setAlertBody(data?.errorMessage || "O link não é válido para criação de senha.");
          } else if (data?.notFound) {
            setAlertTitle("Usuário não encontrado");
            setAlertBody(data?.transaction || "Não localizamos o usuário para este link utilizado.");
          } else if (data?.validationTokenMissing) {
            setAlertTitle("Ops! não é possível criar a senha");
            setAlertBody("Não é possível criar a senha. Ou a senha já foi criada ou há um problema com o link recebido. Caso não saiba a senha, utilize o recurso de recuperar senha na tela de login.");
          } else if (data?.validationTokenMismatch) {
            setAlertTitle("Link inválido");
            setAlertBody("Há um problema com o link que você está utilizando pois não tem relação com o usuário que quer criar a senha. Utilize o recurso de recuperar senha na tela de login.");
          } else if (data?.errorType === 'params') {
            setAlertTitle("Dados incompletos");
            setAlertBody(data?.errorMessage || "Parâmetros obrigatórios ausentes.");
          } else if (data?.errorMessage) {
            setAlertTitle("Não foi possível criar a senha");
            setAlertBody(data.errorMessage);
          } else {
            setAlertTitle("Não foi possível criar a senha");
            setAlertBody("Tente novamente em instantes. Se persistir, entre em contato com o suporte.");
          }

          setAlert(true);
        }
      };

      // chama action createPassword (pública)
      createPassword({ authtoken: token, password }, handlers);
    })
    .catch((e) => {
      setSaving(false);
      setAlertTitle("Ops! ReCaptcha");
      setAlertBody("O ReCaptcha do Google não carregou corretamente. Recarregue a página para corrigir.");
      setAlert(true);
    });
};

  // UI (mantém estrutura existente do formulário e do Password)
  return (
    <>
      <div id="loginSection" className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
        <div className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 
          <div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{justifyContent:"center"}}>
            <div className="formWrapper" style={{margin:"0 auto",maxWidth:"32rem"}}>
              <div className="formTitle">Crie sua senha de acesso</div>
              <div className="formSubTitle">
                Defina a senha de acesso do seu usuário. Esse acesso expira em 60 minutos após o recebimento do email.
              </div>

              <Grid container spacing={4} style={{marginTop:"-20px"}}>
                <Grid item xs={12} sm={12}>
                  <span className="p-float-label">
                    <Password
                      inputId="password"
                      inputProps={{ autoComplete: "new-password" }}
                      autoComplete="new-password"
                      disabled={saving ? true : false}
                      toggleMask
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={{width:"100%"}}
                      feedback={true}
                      promptLabel="Escolha uma senha"
                      weakLabel="Senha fraca"
                      mediumLabel="Senha média"
                      strongLabel="Senha forte"
                      footer={PasswordTip}
                      tooltip="A senha tem que ser no mínimo média"
                      tooltipOptions={{ position: 'bottom', event: 'focus' }}
                    />
                    <label htmlFor="password">Senha <span className="requiredField">*</span></label>
                  </span>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <span className="p-float-label">
                    <Password
                      inputId="passwordConfirm"
                      inputProps={{ autoComplete: "new-password" }}
                      autoComplete="new-password"
                      disabled={saving ? true : false}
                      toggleMask
                      value={passwordConfirm}
                      onChange={(e) => setPasswordConfirm(e.target.value)}
                      style={{width:"100%"}}
                      feedback={false}
                    />
                    <label htmlFor="passwordConfirm">Confirme a senha <span className="requiredField">*</span></label>
                  </span>
                </Grid>
              </Grid>

              <div className="formActions">
                {/* wrap em span para permitir tooltip mesmo com botão disabled */}
                <span className="btn-set-password-wrapper">
                  <Button
                    label="Gravar senha"
                    rounded
                    className="mR10 headerButton tColorWhite w100 btn-set-password"
                    style={{marginBottom:"0.625rem"}}
                    loading={saving}
                    disabled={!canSubmit}
                    onClick={savePassword}
                  />
                </span>
                {disabledReason && (
                  <Tooltip target=".btn-set-password" content={disabledReason} position="bottom" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <AboutUs />
      <ContactUs />

      <AlertView
        alert={alert}
        setAlert={setAlert}
        alertTitle={alertTitle}
        alertBody={alertBody}
        scrollBlock={false}
      />
    </>
  );
};

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus
});
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...LoginActions, ...UserActions }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordSetup);
